/* eslint-disable @typescript-eslint/no-explicit-any */
type Constructor<T = object> = new (...args: any[]) => T;

export function TrackInstances<T extends Constructor>(Base: T): T & { getInstances(): InstanceType<T>[] } {
  const instances: InstanceType<T>[] = [];

  return class extends Base {
    constructor(...args: any[]) {
      super(...args);
      instances.push(this as InstanceType<T>);
    }

    static getInstances(): InstanceType<T>[] {
      return instances;
    }
  };
}

export function getInstances<T>(instance: unknown): T[] {
  const constructorWithGetInstances = instance?.constructor as {
    getInstances?: () => T[];
  };

  if (typeof constructorWithGetInstances.getInstances === 'function') {
    return constructorWithGetInstances.getInstances();
  }

  throw new Error('getInstances() not available on constructor');
}
